import { EVENTS } from "../actionTypes";


const initialState = {
    events: [],
    arrCorporateActionTypes: [],
    activeEvent: "",
    selectedDate: null,
    eventsSearchText: '',
    isEventFailed: false,
    boardMeeting: [],
    bookClosure: [],
    split: [],
    bonus: [],
    dividend: [],
    rights: [],
    agm: [],
    buy_back: [],
    egm: [],
    isEventPending: false,
    bIsCorporateActionApiPending: false,
    objDetailedEvent: {}

};

const eventReducer = (state = initialState, actions) => {
    switch (actions.type) {
        case EVENTS.GET_EVENTS_SUCCESS:
            return {
                ...state,
                isEventFailed: false,
                events: actions.payload,
                arrCorporateActionTypes: [
                    {
                        id: '1',
                        actionType: "Board Meeting",
                        actionInfo: [{
                            date: "26 MAR '22",
                            resultType: "Quarterly Results",
                            eventType: "Upcomming"
                        }, {
                            date: "26 MAR '22",
                            resultType: "Quarterly Results",
                            eventType: ''
                        }, {
                            date: "26 MAR '22",
                            resultType: "Quarterly Results",
                            eventType: ''
                        },
                        ]
                    },
                    {
                        id: '2',
                        actionType: "Book Closure",
                        actionInfo: [{
                            date: "26 MAR 22",
                            resultType: "Quarterly Results",
                            eventType: 'Upcomming'
                        }, {
                            date: "26 MAR 22",
                            resultType: "Quarterly Results",
                            eventType: ''
                        }, {
                            date: "26 MAR 22",
                            resultType: "Quarterly Results",
                            eventType: ''
                        },
                        ]
                    },
                    {
                        id: '3',
                        actionType: "AGM",
                        actionInfo: [{
                            date: "26 MAR 22",
                            resultType: "Quarterly Results",
                            eventType: 'Upcomming'
                        }, {
                            date: "26 MAR 22",
                            resultType: "Quarterly Results",
                            eventType: ''
                        }, {
                            date: "26 MAR 22",
                            resultType: "Quarterly Results",
                            eventType: ''
                        },
                        ]
                    },
                    {
                        id: '4',
                        actionType: "EGM",
                        actionInfo: [{
                            date: "26 MAR 22",
                            resultType: "Quarterly Results",
                            eventType: 'Upcomming'
                        }, {
                            date: "26 MAR 22",
                            resultType: "Quarterly Results",
                            eventType: ''
                        }, {
                            date: "26 MAR 22",
                            resultType: "Quarterly Results",
                            eventType: ''
                        },
                        ]
                    },
                    {
                        id: '5',
                        actionType: "Split",
                        actionInfo: [{
                            date: "26 MAR 22",
                            resultType: "Quarterly Results",
                            eventType: ''
                        }, {
                            date: "26 MAR 22",
                            resultType: "Quarterly Results",
                            eventType: ''
                        }, {
                            date: "26 MAR 22",
                            resultType: "Quarterly Results",
                            eventType: ''
                        },
                        ]
                    },
                    {
                        id: '6',
                        actionType: "Dividend",
                        actionInfo: [{
                            date: "26 MAR 22",
                            resultType: "Quarterly Results",
                            eventType: 'Upcomming'
                        }, {
                            date: "26 MAR 22",
                            resultType: "Quarterly Results",
                            eventType: ''
                        }, {
                            date: "26 MAR 22",
                            resultType: "Quarterly Results",
                            eventType: ''
                        },
                        ]
                    }
                ]
            };
        case EVENTS.GET_EVENT_PENDING_STATUS:
            return {
                ...state,
                isEventPending: actions.payload
            };
        case EVENTS.CLEAR_EVENTS_STATES:
            return {
                ...state,
                eventsSearchText: '',
                isEventFailed: false,
                events: []
            };
        case EVENTS.UPDATE_EVENTS_SEARCH_TEXT:
            return {
                ...state,
                eventsSearchText: actions.payload
            };
        case EVENTS.UPDATE_ACTIVE_EVENT_TAB:
            return {
                ...state,
                activeEvent: actions.payload
            };

        case EVENTS.GET_EVENTS_FAILURE: {
            return {
                ...state,
                isEventFailed: true,
                events: []

            };
        }
        case EVENTS.IS_CORPORATE_ACTION_PENDING: {
            return {
                ...state,
                bIsCorporateActionApiPending: actions.payload
            };
        }

        case EVENTS.UPDATE_EVENT_DATE:
            return {
                ...state,
                selectedDate: actions.payload
            };

        //MAhesh S:26-10-23 :BT-107375 - Breeze - Scrip -info-events - Start
        case EVENTS.GET_BOARD_MEETING_SUCCESS:
            return { ...state, boardMeeting: actions.payload };
        case EVENTS.GET_BOARD_MEETING_FAILURE:
            return { ...state, boardMeeting: actions.payload };
        case EVENTS.GET_BOOK_CLOSURE_SUCCESS:
            return { ...state, bookClosure: actions.payload };
        case EVENTS.GET_BOOK_CLOSURE_FAILURE:
            return { ...state, bookClosure: actions.payload };
        case EVENTS.GET_SPLITS_DATA_SUCCESS:
            return { ...state, split: actions.payload };
        case EVENTS.GET_SPLITS_DATA_FAILURE:
            return { ...state, split: actions.payload };
        case EVENTS.GET_DIVIDEND_DATA_SUCCESS:
            return { ...state, dividend: actions.payload };
        case EVENTS.GET_DIVIDEND_DATA_FAILURE:
            return { ...state, dividend: actions.payload };
        case EVENTS.GET_RIGHTS_DATA_SUCCESS:
            return { ...state, rights: actions.payload };
        case EVENTS.GET_RIGHTS_DATA_FAILURE:
            return { ...state, rights: actions.payload };
        case EVENTS.GET_BONUS_DATA_SUCCESS:
            return { ...state, bonus: actions.payload };
        case EVENTS.GET_BONUS_DATA_FAILURE:
            return { ...state, bonus: actions.payload };
        case EVENTS.GET_AGM_SUCCESS:
            return { ...state, agm: actions.payload };
        case EVENTS.GET_AGM_FAILURE:
            return { ...state, agm: actions.payload };
        case EVENTS.GET_EGM_SUCCESS:
            return { ...state, egm: actions.payload };
        case EVENTS.GET_EGM_FAILURE:
            return { ...state, egm: actions.payload };
        case EVENTS.GET_BUY_BACK_SUCCESS:
            return { ...state, buy_back: actions.payload };
        case EVENTS.GET_BUY_BACK_FAILURE:
            return { ...state, buy_back: actions.payload };

        //MAhesh S:26-10-23 :BT-107375 - Breeze - Scrip -info-events - End

        case EVENTS.UPDATE_EVENT_DETAILS:
            return {
                ...state,
                objDetailedEvent: actions.payload
            };
        default:
            return state;
    }

};

export default eventReducer;